import { useAppDispatch } from '@/shared/lib/redux'
import {
    openCreateInvoiceModal as openCreateInvoiceModalAction
} from '../../model'

export const useCreateInvoiceModal = () => {
    const dispatch = useAppDispatch()

    const openCreateInvoiceModal = (onCreate?: () => void) => {
        dispatch(openCreateInvoiceModalAction({
            onCreate
        }))
    }
    
    return {
        openCreateInvoiceModal,
    }
}